<template>
    <div
        v-if="chars.left != null && chars.total != null"
        class="chars-info"
        :class="{ hide: !showInfo }"
    >
        <button @click="toggle()">
            <IconInfo />
        </button>

        <div
            v-tooltip="
                `For editing purposes, you have ${chars.total} characters within the project. <br> Once the limit is reached, you will no longer be able to edit the project. <br> You’ll be able to download the final audio.`
            "
        >
            {{ Math.max(0, chars.left) }}/{{ chars.total }} characters left
        </div>
        <!-- <div v-else>
            Unlimited characters
        </div> -->
    </div>
</template>

<script>
import { fetchCharInfo } from '../../api/books';
import { IconInfo } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'EditorLightCharsInfo',
    components: {
        IconInfo
    },
    props: {
        book: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            chars: {},
            showInfo: true
        };
    },
    inject: ['registerWsHandler', 'removeWsHandler'],
    async created() {
        this.registerWsHandler('record_process_book_part_update', this.handleMessage);

        try {
            this.chars = await fetchCharInfo(this.book);
        } catch (e) {
            // Guests without chars_info permission get a 403 here (the
            // shared axios wrapper rejects with `{ ...data, status }`); the
            // widget stays hidden via the template's v-if in that case.
            // Any other error should propagate like it did before this
            // try/catch was introduced.
            if (!e || e.status !== 403) {
                throw e;
            }

            this.chars = {};
        }
    },
    beforeUnmount() {
        this.removeWsHandler('record_process_book_part_update', this.handleMessage);
    },
    methods: {
        handleMessage({ params = {} }) {
            if (params.action === 'generate' && params.book_id === this.book && params.chars) {
                this.chars = params.chars || {};
            }
        },
        toggle() {
            this.showInfo = !this.showInfo;
        }
    }
};
</script>

<style src="./CharsInfo.scss" lang="scss"></style>
